import React, { useEffect, useState, useRef } from "react";
import Header from "./Header";
import fire from "./Firebase";
import "../App.css";
import { useReactToPrint } from "react-to-print";
import { toast } from "react-toastify";
import * as htmlToImage from "html-to-image";

function Try4() {
  document.title = "HR School-Single Certificate";

  // const conponentPDF = useRef();
  const [usercertificate4, setusercertificate4] = useState([]);
  const domEl = useRef({});
  const downloadImage = async () => {
    const dataUrl = await htmlToImage.toJpeg(domEl.current);

    // download image
    const link = document.createElement("a");
    link.download = "html-to-img.jpeg";
    link.href = dataUrl;
    link.click();
  };
  useEffect(() => {
    fire
      .child(`certificates/${sessionStorage.getItem("lastname4")}`)
      .on("value", (sna) => {
        setusercertificate4([sna.val()]);
      });
  }, []);
  // const generatePDF = useReactToPrint({
  //   content: () => conponentPDF.current,
  //   documentTitle: "Userdata",
  //   onAfterPrint: () => toast("Data saved in PDF"),
  // });
  return (
    <div>
      <Header />
      <div>
        <div>
          {usercertificate4.map((datas4) => {
            return (
              <>
                <div style={{ margin: "20px",textTransform:"uppercase" }} ref={domEl}>
                  <div className="temp4container relative">
                    <div className="temp4background relative">
                      <div className="content-wrapper">
                        <div className="temp4header relative">
                          <div className="logo-mitra-wrapper title-top1">
                            HR School
                          </div>
                        </div>
                       
                        <br />
                        <h2>CERTIFICATE OF COMPLETION</h2> <br />
                        <h3 style={{color:"green"}}>
                          CERTIFIED {datas4.Field} SPECIALIST
                        </h3>{" "}
                        <br />
                        <p>THIS IS TO CERTIFY THAT</p>
                        <p className="temp4name">
                          NAME :- {datas4.Gender} {datas4.Name}
                        </p>
                        <p className="temp4name">
                          FATHER NAME :- {datas4.Father}
                        </p>
                        <p className="temp4name">
                          COURSE DURATION :- {datas4.Course} MONTHS
                        </p>
                        <p className="temp4name">
                          COURSE NAME :- {datas4.Coursename}
                        </p>
                        <hr className="divider" />
                        <p className="completing">
                          THE BEAUTIFUL THING ABOUT LEARNING IS THAT NO ONE CAN
                          TAKE IT AWAY FROM YOU.
                        </p>
                        <p className="course-title">
                          HAS SUCCESSFULLY COMPLETED THE {datas4.Coursename}{" "}
                          COURSE WITH HR SCHOOL
                        </p>
                        <p className="course-title2" style={{color:"green"}}>
                          {" "}
                          WITH SCORE OF {datas4.grade}
                        </p>
                        <p className="course-title2">Dated</p>
                        <p className="course-title3">
                          START DATE :- {datas4.startdate}/{datas4.startmonth}/
                          {datas4.startyear}
                        </p>
                        <p className="course-title3">
                          END DATE :- {datas4.enddate}/{datas4.endmonth}/
                          {datas4.endyear}
                        </p>
                        <p className="course-title2">www.hrschool.com</p>
                        <div className="left-block"></div>
                        <div className="right-block"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            );
          })}
        </div>
      </div>
      <center>
        {" "}
        <br />
        {/* <button onClick={() => generatePDF()}>
                    Convert In PDF
                  </button> */}
        <button onClick={downloadImage} style={{ color: "black" }}>
          Download Image
        </button>
      </center>
    </div>
  );
}

export default Try4;
